import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { createLogger } from 'redux-logger'
import { batchDispatchMiddleware } from 'redux-batched-actions';

import createRootReducer from './rootReducer'

export const history = createBrowserHistory();

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['auth', 'router', 'layout', 'stickers']
  // blacklist: ['auth', 'router', 'layout']
};

const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

const initialState = {};
const enhancers = [] as any[];
const middleware = [thunk, routerMiddleware(history), batchDispatchMiddleware];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
  const logger = createLogger({
    timestamps: true,
    duration: true
  });
  middleware.push(logger);
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(
  persistedReducer,
  initialState,
  composedEnhancers
);

export default store;
export const persistor = persistStore(store);